import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';

import { map, switchMap } from 'rxjs/operators';
import { UserService } from '../../lib/services';
import {
  ActionTypes,
  CurrentUserLoaded,
  CurrentUserRequested,
} from '../actions/auth';

@Injectable()
export class AuthEffects {
  @Effect()
  loadCurrentUser = this.actions$.pipe(
    ofType<CurrentUserRequested>(ActionTypes.CurrentUserRequested),
    switchMap(() =>
      this.userService
        .getCurrentUser()
        .pipe(map(user => new CurrentUserLoaded({ currentUser: user })))
    )
  );

  constructor(private actions$: Actions, private userService: UserService) {}
}
